<template>
    <div v-if="jackpots.length || winningJackpot" class="bng-jackpots-bar">
        <div class="jackpots scrollbar">
            <jackpot v-for="jp in jackpots" :key="jp.id" :jackpot="jp"></jackpot>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';

import balanceService from '../../../../../../_common/services/balance.service';
import jackpotService from '../../../../../../_common/services/jackpot.service';

import Jackpot from '../jackpot/jackpot.vue';
import Confetti from '../../../../../../_common/components/confetti.vue';

export default {
    name: 'jackpots-bar',
    components: { Jackpot, Confetti },
    data() {
        return {
            loading: false
        };
    },
    computed: {
        player() {
            return Vue.state.player.get();
        },
        jackpots() {
            return (this.player && this.player.balance && this.player.activeJackpots) || [];
        },
        winningJackpot() {
            if (this.$refs.confetti) {
                if (this.player && this.player.winningJackpot) {
                    this.$refs.confetti.start();
                    setTimeout(() => {
                        this.$refs.confetti.stop();
                    }, 10);
                } else if (this.$refs.confetti.active) this.$refs.confetti.stop();
            }

            return this.player && this.player.winningJackpot;
        }
    },
    methods: {
        async take() {
            this.loading = true;
            await jackpotService.take(this.winningJackpot.id);
            Vue.state.player.unsetWinningJackpot();
            this.loading = false;
        }
    }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/jackpots/jackpots-bar/jackpots-bar.vue